/**
 * Induction Machine — "Rotor Specification" group in topologies.ts.
 * Double Cage upper / lower blocks are delimited by comments:
 * - "// ✅ Double Cage // Upper Cage Data // ADD DIVIDER" → first key below
 * - "// ✅ Double Cage // Lower Cage Data // ADD DIVIDER" → first key below
 */
export const INDUCTION_MACHINE_TOPOLOGY = "Induction Machine";
export const ROTOR_SPECIFICATION_GROUP = "Rotor Specification";

/** First parameter key of the upper-cage block (after common double-cage + end-ring common fields). */
export const DOUBLE_CAGE_UPPER_BLOCK_FIRST_KEY = "rotor_tooth_tip_angle_upper";

/** First parameter key of the lower-cage block. */
export const DOUBLE_CAGE_LOWER_BLOCK_FIRST_KEY = "rotor_tooth_tip_angle_lower";

export const shouldShowDoubleCageRotorDividers = (values: Record<string, any>): boolean =>
    values?.rotor_type === "Squirrel Cage" && values?.cage_type === "Double Cage";
